var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 36,
    height: 36,
    rx: 8,
    transform: "rotate(-90 0 36)",
    fill: "#40C1AC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 36,
    height: 36,
    rx: 8,
    transform: "rotate(-90 0 36)",
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9577 18C26.9577 22.9416 22.941 26.9583 17.9993 26.9583C13.0577 26.9583 9.04102 22.9416 9.04102 18C9.04102 13.0583 13.0577 9.04164 17.9993 9.04164C22.941 9.04164 26.9577 13.0583 26.9577 18ZM10.291 18C10.291 22.25 13.7493 25.7083 17.9993 25.7083C22.2493 25.7083 25.7077 22.25 25.7077 18C25.7077 13.75 22.2493 10.2916 17.9993 10.2916C13.7493 10.2916 10.291 13.75 10.291 18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 15.9167L18.625 20.9167C18.625 21.2584 18.3417 21.5417 18 21.5417C17.6583 21.5417 17.375 21.2584 17.375 20.9167L17.375 15.9167C17.375 15.575 17.6583 15.2917 18 15.2917C18.3417 15.2917 18.625 15.575 18.625 15.9167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1249 17.5833C21.1249 17.7417 21.0665 17.9 20.9415 18.025C20.6999 18.2667 20.2999 18.2667 20.0582 18.025L17.9999 15.9667L15.9415 18.025C15.6999 18.2667 15.2999 18.2667 15.0582 18.025C14.8165 17.7833 14.8165 17.3833 15.0582 17.1417L17.5582 14.6417C17.7999 14.4 18.1999 14.4 18.4415 14.6417L20.9415 17.1417C21.0665 17.2667 21.1249 17.425 21.1249 17.5833Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoUp);
export default __webpack_public_path__ + "static/media/go-up.3f9794a8008b85717c989048775d6336.svg";
export { ForwardRef as ReactComponent };